<CardBase {element}>
  <div style="width: 100cqw; --f7-input-clear-button-size: 0px; --f7-input-focused-border-color: transparent;">
    {#if state !== State.NONE}
      <div class="close-wrapper">
        <img src={closeImg} alt="close-background">
        <button type="button" class="button" on:click={() => onExpand(State.NONE)}>Close</button>
      </div>
    {/if}
    <div class="chat-input-wrapper">
      <div class="chat-input">
        {#if showGiphyButton}
        <div class="icon-gif" on:click={() => onExpand(State.GIF)}>
          <img src={state === State.GIF ? iconGif2 : iconGif} alt="insert-gif" />
        </div>
        {/if}
        {#if showXButton}
        <div class="icon-twitter" on:click={() => onExpand(State.TWITTER)}>
          <img src={state === State.TWITTER ? iconTwitter2 : iconTwitter} alt="insert-tweet" />
        </div>
        {/if}
        <div class="chat-input-textbox" on:keydown={(e) => { if (e.key === 'Enter') { e.preventDefault(); sendMessage(); } }}>
          <List noHairlines>
            <ListInput
              type="text"
              placeholder="Message the group..."
              clearButton
              bind:value={textContent}
              onInput={(e) => textContent = e.target.value}
              class="list-input"
            />
          </List>
        </div>
        <div class="chat-input-button emoj" bind:this={trigger}>
          <img src={iconEmoji} alt="emoji-button" on:click={() => picker.togglePicker(trigger)} />
        </div>
        <div class="chat-input-button send">
          <img src={sendActive ? iconSend2 : iconSend} alt="send-button" on:click={sendMessage} />
        </div>
      </div>
      {#if state === State.GIF}
        <div class="gif-container" in:spin="{{duration: 300}}" out:spin="{{duration: 300}}">
          {#each mediaGiphy as item}
            <div class="gif-wrapper" on:click={e => sendMedia(item)}>
              <img src={item.MediaUrl} alt="gif-item">
            </div>
          {/each}
        </div>
      {:else if state === State.TWITTER}
        <div class="twitter-container" in:spin="{{duration: 300}}" out:spin="{{duration: 300}}">
          <div class="twitter-container-1">
            {#each mediaTwitter as item}
              <div class="twitter-wrapper">
                {#if item.MediaUrl && (item.SourceName !== "twitter" || item.MediaUrl.endsWith(".jpg"))}
                  <img
                    src={item.MediaUrl}
                    alt="thumbnail"
                    class="thumbnail"
                  />
                {/if}
                <div class="content-layout">
                  <article>
                    {item.TextContent}
                  </article>
                  <div class="footer">
                    <div class="author-layout">
                      <h4 for="" class="author">{item.Author}</h4>
                      <label for="" class="source">via {item.SourceName}</label>
                    </div>
                    <button class="btn-add" on:click={e => sendMedia(item)}><span>ADD</span><i class="f7-icons">chevron_up</i></button>
                  </div>
                </div>
              </div>
            {/each}
          </div>
        </div>
      {/if}
    </div>
  </div>
</CardBase>

<style type="text/scss">*, *:before, *:after {
  box-sizing: border-box;
}

.chat-input-wrapper {
  background: white;
}

.chat-input {
  padding: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  position: relative;
  background: white;
}

.chat-input-textbox {
  flex: 1 0 75%;
  width: 75%;
  border: 1px solid #979797;
  border-radius: 30px;
  overflow: hidden;
}

.icon-gif, .icon-twitter {
  margin: 0 6px 0 0;
  min-width: 35px;
  max-width: 45px;
}

.icon-gif img, .icon-twitter img {
  width: 100%;
  height: 100%;
  display: block;
}

.chat-input-button {
  flex: 0 0;
  padding: 0px 10px;
  position: absolute;
  line-height: 0;
}

.chat-input-button.emoj {
  right: 35px;
}

.chat-input-button.emoj img {
  width: 40px;
}

.chat-input-button.send {
  right: 6px;
}

.chat-input-button.send img {
  width: 30px;
}

.chat-input-button img {
  position: relative;
  z-index: 1;
}

:global(.list-input) {
  padding: 0 70px 0 0;
  font-size: 12px;
  --f7-input-font-size: 12px;
  --f7-list-item-min-height: 36px;
  --f7-list-item-padding-vertical: 0;
  --f7-input-height: 36px;
}

.gif-container {
  background: white;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 6px;
  gap: 6px;
  margin: 5px 0 0 0;
  height: calc(100vh - 400px);
  overflow-y: auto;
  padding: 0 10px;
}

.gif-container .gif-wrapper img {
  width: 100%;
  display: block;
}

.close-wrapper {
  height: 68px;
  position: relative;
  width: 100%;
}

.close-wrapper img {
  display: block;
  width: 100%;
}

.close-wrapper button {
  line-height: 22px;
  position: absolute;
  width: 72px;
  left: calc(50% - 36px);
  height: 22px;
  border-radius: 50px;
  top: 37px;
  border: 2px solid #eaeaea;
  padding: unset;
  text-transform: uppercase;
  font-size: 12px;
}

.twitter-container {
  background: white;
  display: flex;
  flex-wrap: wrap;
  grid-gap: 6px;
  gap: 6px;
  margin: 5px 0 0 0;
  height: calc(100vh - 400px);
  overflow-y: auto;
  padding: 0 10px;
}

.twitter-container .twitter-container-1 {
  -webkit-columns: 2;
  -moz-columns: 2;
  columns: 2;
}

.twitter-container .twitter-container-1 .twitter-wrapper {
  width: 100%;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  border-radius: 10px;
  border: solid 2px #e4e5e6;
  box-shadow: 0 0 2px 1px #e4e5e6;
  overflow: hidden;
  margin: 2px;
  display: inline-flex;
  flex-direction: column;
}

.twitter-container .twitter-container-1 .twitter-wrapper .badge {
  font-size: 16px;
  position: absolute;
  color: #00833e;
  top: 5px;
  padding: 0;
  width: 16px;
  right: 5px;
  border: none;
  height: 18px;
  background: white;
  display: flex;
}

.twitter-container .twitter-container-1 .twitter-wrapper img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.twitter-container .twitter-container-1 .twitter-wrapper .content-layout {
  padding: 10px;
  width: 100%;
  font-family: 'SF UI Display';
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: #000;
}

.twitter-container .twitter-container-1 .twitter-wrapper .content-layout article {
  width: 100%;
  overflow: hidden;
  --max-lines: 5;
  --lineHeight: 25.2px;
  max-height: calc(var(--max-lines) * var(--lineHeight));
  overflow: hidden;
  position: relative;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  font-family: 'SF UI Display';
}

.twitter-container .twitter-container-1 .twitter-wrapper .content-layout article::before {
  position: absolute;
  content: "...";
  bottom: 0;
  right: 0;
}

.twitter-container .twitter-container-1 .twitter-wrapper .content-layout .footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}

.twitter-container .twitter-container-1 .twitter-wrapper .content-layout .footer .author-layout {
  flex: 1;
  display: block;
}

.twitter-container .twitter-container-1 .twitter-wrapper .content-layout .footer .author-layout .author {
  font-weight: bold;
  margin: 0;
  font-family: 'SF UI Display';
  word-break: break-all;
}

.twitter-container .twitter-container-1 .twitter-wrapper .content-layout .footer .author-layout .source {
  color: #505050;
  font-family: 'SF UI Display';
}

.twitter-container .twitter-container-1 .twitter-wrapper .content-layout .footer i {
  font-size: 12px;
  color: black;
  font-weight: bold;
}

.twitter-container .twitter-container-1 .twitter-wrapper .content-layout .btn-add {
  width: 60px;
  height: 30px;
  background: #1050fb;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border-radius: 15px;
  border: none;
  font-family: 'SF UI Display';
  font-size: 12px;
  color: white;
}

.twitter-container .twitter-container-1 .twitter-wrapper .content-layout .btn-add i {
  margin: 0 0 0 4px;
  color: white;
}</style>

<script lang="ts">var _a, _b, _c, _d, _e, _f, _g;
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import { List, ListInput, Link } from 'framework7-svelte';
import { EmojiButton } from '@joeattardi/emoji-button';
import { pushMessage } from '../common/index';
import { v4 as uuid4 } from 'uuid';
import CardBase from "../../../common/CardBase.svelte";
import { getToken } from "inversify-token";
import ROOT from "../../../../../inversify.config";
import { YinzCamDropsServerToken } from "yinzcam-drops";
import { findSourceStore } from "../../../utilities";
import { Readable } from "svelte/store";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { CardsTabContext, CardsTabContextKey, } from "../../../common/context";
import { getContext } from "svelte";
import iconGif from "./images/jess/GIF1.png";
import iconTwitter from "./images/jess/X1.png";
import iconGif2 from "./images/jess/GIF2.png";
import iconTwitter2 from "./images/jess/X2.png";
import closeImg from "./images/close.png";
import iconEmoji from "./images/jess/EMOJI.png";
import iconSend from "./images/jess/SEND1.png";
import iconSend2 from "./images/jess/SEND2.png";
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
const showXButton = (_b = (_a = CONFIG.ui) === null || _a === void 0 ? void 0 : _a.chatShowXButton) !== null && _b !== void 0 ? _b : true;
const showGiphyButton = (_d = (_c = CONFIG.ui) === null || _c === void 0 ? void 0 : _c.chatShowGiphyButton) !== null && _d !== void 0 ? _d : true;
var State;
(function (State) {
    State["GIF"] = "giphy";
    State["TWITTER"] = "twitter";
    State["NONE"] = "none";
})(State || (State = {}));
let sourceMedia;
let key;
let mediaGiphy = [];
let mediaTwitter = [];
$: sourceStore = findSourceStore($sources, 'YinzCamDropsServerCurrentDrop');
$: sourceMedia = findSourceStore($sources, 'YinzCamChatMedia');
$: profileStore = findSourceStore($sources, 'YinzCamSignonProfileSegment');
$: data = (sourceStore && $sourceStore) ? $sourceStore : null;
$: active = (data === null || data === void 0 ? void 0 : data.Active) || false;
$: dropUuid = data === null || data === void 0 ? void 0 : data.Id;
$: {
    mediaGiphy = ((_e = $sourceMedia === null || $sourceMedia === void 0 ? void 0 : $sourceMedia.Media) === null || _e === void 0 ? void 0 : _e.filter(e => (e === null || e === void 0 ? void 0 : e.SourceName) === "giphy")) || [];
    mediaTwitter = ((_f = $sourceMedia === null || $sourceMedia === void 0 ? void 0 : $sourceMedia.Media) === null || _f === void 0 ? void 0 : _f.filter(e => (e === null || e === void 0 ? void 0 : e.SourceName) === "twitter")) || [];
}
$: key = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.key) || "";
const picker = new EmojiButton();
const dropsServer = getToken(ROOT, YinzCamDropsServerToken);
let textContent = '';
let trigger;
let state = State.NONE;
$: sendActive = (textContent === null || textContent === void 0 ? void 0 : textContent.length) > 0 && active && dropUuid;
picker.on('emoji', selection => {
    textContent += selection.emoji;
});
function sendMedia(item) {
    state = State.NONE;
    dropsServer.postDropMessage(dropUuid, {
        Id: uuid4(),
        UserId: $profileStore.Id,
        SendTime: (new Date()).getTime(),
        ImageUrl: "",
        MediaId: item.Id,
        MediaTextContent: item.TextContent,
        MediaUrl: item.MediaUrl,
        MediaAuthor: item.Author,
        MediaSourceName: item.SourceName,
        MediaEmbedUrl: "",
        HeaderText: "",
        BodyText: textContent,
        Admin: false,
        Sticky: false
    }).then(() => console.log('drop media posted!'));
}
function sendMessage() {
    if (!textContent || !active || !dropUuid) {
        return;
    }
    dropsServer.postDropMessage(dropUuid, {
        Id: uuid4(),
        UserId: $profileStore.Id,
        SendTime: (new Date()).getTime(),
        ImageUrl: "",
        MediaId: "",
        MediaTextContent: "",
        MediaUrl: "",
        MediaAuthor: "",
        MediaSourceName: "",
        MediaEmbedUrl: "",
        HeaderText: "",
        BodyText: textContent,
        Admin: false,
        Sticky: false
    }).then(() => console.log('drop chat posted!'));
    textContent = '';
}
function onExpand(_state) {
    state = _state;
    tabContext.setParam(key, _state);
}
function spin(node, { duration }) {
    return {
        duration,
        css: t => {
            return `
          height: calc((100vh - 400px) * ${t});
        `;
        }
    };
}
</script>